export type FundsEmptyFilter = 'show' | 'hide';

export interface FundsPagePreferences {
  emptyFilter: FundsEmptyFilter;
}

const DEFAULT_PREFERENCES: FundsPagePreferences = {
  emptyFilter: 'show',
};

function getPreferencesStorageKey(churchId?: string) {
  return churchId ? `giving-funds-page-preferences:${churchId}` : 'giving-funds-page-preferences';
}

export function loadFundsPagePreferences(churchId?: string): FundsPagePreferences {
  if (typeof window === 'undefined') {
    return DEFAULT_PREFERENCES;
  }

  try {
    const raw = window.localStorage.getItem(getPreferencesStorageKey(churchId));
    if (!raw) {
      return DEFAULT_PREFERENCES;
    }

    const parsed = JSON.parse(raw) as Partial<FundsPagePreferences>;
    return {
      emptyFilter: parsed.emptyFilter === 'hide' ? 'hide' : 'show',
    };
  } catch {
    return DEFAULT_PREFERENCES;
  }
}

export function persistFundsPagePreferences(
  churchId: string | undefined,
  preferences: FundsPagePreferences,
) {
  if (typeof window === 'undefined') {
    return;
  }

  try {
    window.localStorage.setItem(
      getPreferencesStorageKey(churchId),
      JSON.stringify(preferences),
    );
  } catch {
    // Ignore storage failures and fall back to the in-memory state for this session.
  }
}
